// The backend stores twelve product categories but only a few have their own
// picture, so the smaller ones fall in with accessories.
const CATEGORY_ICONS = {
  BAGS: 'bags',
  SHOES: 'shoes',
  WATCHES: 'watches',
  APPAREL: 'clothing',
  ACCESSORIES: 'accessories',
  JEWELLERY: 'accessories',
  SCARVES: 'accessories',
  WALLETS: 'accessories',
  SUNGLASSES: 'accessories',
  PENS: 'accessories',
  FRAGRANCES: 'accessories',
  HOMEWARE: 'accessories',
};

export default (category) => CATEGORY_ICONS[category] || 'accessories';
